import { Injectable } from '@angular/core';
import {NodeApiService} from '../network/online/node/node-api.service';
import {PeerConnectionApiService} from '../peer-connection/peer-connection-api.service';
import {VoipPeerApiService} from '../network/online/voip-peer/voip-peer-api.service';
import {HttpClient, HttpBackend} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardApiService {
  basicHttpClient;

  constructor(private http: HttpClient,
              private nodeApiService: NodeApiService,
              private peerConnectionApiService: PeerConnectionApiService,
              private voipPeerApiService: VoipPeerApiService,
              private handler: HttpBackend) {
    this.basicHttpClient = new HttpClient(handler);
  }

  newUpdatesUrl = 'https://armaudiocodes.blob.core.windows.net/default/arm.json';

  onlineNodeImg = 'assets/images/topology/node_online.svg';
  onlinePeerConnectionImg = 'assets/images/topology/peer_connection_online.svg';
  onlineVoipPeerImg = 'assets/images/topology/voip_peer_online.svg';

  public externalData(): Promise<any> {
    return Promise.all([
      this.nodeApiService.getNodes(),
      this.peerConnectionApiService.getPCons(),
      this.voipPeerApiService.getVoipPeers()
    ]).then(data => {
      return {
        nodes: this.getRelevantData(data[0], 'Online Node', this.onlineNodeImg),
        pCons: data[1].elements.map(this.generatePeerConnection),
        voipPeers: this.getRelevantData(data[2].elements, 'Online VoIP Peer', this.onlineVoipPeerImg)
      };
    });
  }

  public getNewUpdates(): Observable<any> {
    return this.basicHttpClient.get(this.newUpdatesUrl);
  }

  private getRelevantData(elements, type = null, image = null): any {
    if (type) {
      return elements.map(element => {
        return {id: element.id, name: element.name, elementType: type, image};
      });
    }

    return elements.map(element => {
      return {id: element.id, name: element.name, image};
    });
  }

  private generatePeerConnection = (element) => {
    return {
      id: element.id,
      name: element.name,
      nodeName: element.nodeName,
      nodeId: element.nodeId,
      elementType: 'Online Peer Connection',
      image: this.onlinePeerConnectionImg,
      pConNodeType: element.pConNodeType,
      peerConnectionNodeType: element.peerConnectionNodeType
    };
  }
}
